import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  CtEvetHayirRadioComponent,
  CtGenLookupCokluComponent,
  CtGenLookupComponent,
  LookUp,
} from '@dabnet-kamu/libs/ui';
import { DxButtonModule, DxSelectBoxModule } from 'devextreme-angular';

@Component({
  selector: 'dk-lookup',
  standalone: true,
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.scss'],
  imports: [
    CommonModule,
    CtGenLookupComponent,
    DxButtonModule,
    DxSelectBoxModule,
    CtEvetHayirRadioComponent,
    CtGenLookupCokluComponent
  ],
})
export class LookupComponent {
  public LookUp = LookUp;
  public yesNoCode = '';
  public provinceCode = 0;
  public districtCode = 0;
  public usersCode = 0;
  public periodCode = 2023;
  public incomeCode = 0;
  public tenderCode = 0;
  public expenseCode = 0;
  public kRulerCode = 0;
  public temBACode = 0;
  public temBABACode = 0;
  public registryTypeCode = 0;
  public receiptTypeCode = 0;
  public receiptProcessCode = 0;
  public receiptProcessTypeCode = 0;
  public receiptPaymentTypeCode = 0;
  public billProcessCode = 0;
  public billTypeCode = 0;
  public signatureAuthorityTypeCode = 0;
  public controlDate = new Date();
  public labelValue = 'outside';

  constructor(private router: Router) {}

  change() {
    // selectedRow.OdenekKontrolEh = $event.value;
  }
  changeProvince(e: any) {
    this.provinceCode = e.value;
    this.districtCode = 0;
  }
  changeDistrict(e: any) {
    this.districtCode = e.value;
  }

  mainRoute() {
    this.router.navigate(['/main/dabnet']);
  }

  handleLabelModeChange(event: any) {
    this.labelValue = event.value;
  }
}
